<kendo-combobox #empComboFilter [data]="filteredData" [textField]="textField" [valueField]="valueField()" [valuePrimitive]="true" [filterable]="true"
  (open)="resetList()" (filterChange)="handleAutoCompleteEmployeeFilter($event,empComboFilter)" (valueChange)="onChange($event)" [value]="selectedItem">
</kendo-combobox>